import { Component, Input, OnInit } from '@angular/core';
import { UserContext } from '@core/models';
import { Clients } from '@shared/enums';

export interface IClientLogoSVG {
  name: string;
  paths: Array<string>;
  points?: Array<string>;
  viewBox: string;
}

@Component({
  selector: 'sp-logo',
  template: `
    <div class="logo-container">
      <img [src]="logo" class="imagePosition" />
    </div>
  `,
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit {
  clientName: string;
  svgClass: string;
  logo = '';
  resourcesBaseUrlPrefix = 'https://';

  @Input() client: Clients;
  @Input() spColored?: boolean;
  @Input() set userContext(val: UserContext) {
    if (
      val.programCode.toLowerCase() === val.partnerCode.toLowerCase() ||
      !val.theme.theming.headerLogoUrl
    ) {
      this.applyProgramCodeLogo(val.programCode);
    } else {
      this.applyPartnerCodeLogo(val.theme.theming.headerLogoUrl);
    }
  }

  constructor() {}

  ngOnInit() {
    this.getSvgClass();
    this.getClientName();
  }

  private applyProgramCodeLogo(programCode: string): void {
    let imageName = '';

    switch (programCode.toLowerCase()) {
      case 'sure':
      case 'wf':
      case 'nrth':
        //for clients with program = to SURE and partner code not = to SURE, the logo path comes from the program-config.json in the program config service
        imageName = 'sure_logo.svg';
        break;
      case 'gbop':
      case 'mtbk':
        imageName = 'gbop-logo-new.png';
        break;
      case 'tap':
      case 'acct':
        imageName = 'runpayroll-logo.png';
        break;
      case 'myob':
        imageName = 'accountEdge.png';
        break;
      case 'hunt':
        imageName = 'hunt-logo.jpeg';
        break;
      case 'pxgo':
        imageName = 'pxgo-logo.svg';
        break;
      case 'mnis':
        imageName = 'mnis_logo.svg';
        break;
    }

    this.logo = `assets/logos/${imageName}`;
  }

  private applyPartnerCodeLogo(headerLogoUrl: string): void {
    if (headerLogoUrl.indexOf('.com') >= 0) {
      this.logo = this.resourcesBaseUrlPrefix + headerLogoUrl;
    } else {
      this.logo =
        headerLogoUrl.charAt(0) === '/'
          ? headerLogoUrl.substring(1, headerLogoUrl.length)
          : headerLogoUrl;
    }
  }

  private getSvgClass(): void {
    this.svgClass = `logo-${this.client}${this.spColored ? `-colored` : ``}`;
  }

  private getClientName(): void {
    this.clientName = this.client;
  }
}
